<template>
  <section class="w-md:w-128 pt-16 sm:pt-5" data-testid="viewer-versions-modal">
    <h3 class="mb-1 px-5 font-semibold">Item version history</h3>
    <div class="px-5 pb-5 max-h-[520px] overflow-y-auto flex flex-col gap-6">
      <VersionsSkeleton v-if="loading" />
      <template v-else>
        <VersionsCurrent />
        <VersionsList />
      </template>
    </div>
    <VersionsUpselling
      v-if="free"
      :is-free="true"
      class="px-5 pb-6"
      cta="UPGRADE TO PRO"
      header="Version history"
      message="Keep 100% control over your content. Never lose previous versions, check how your content changed, restore historical versions as new files, or replace them."
    />
    <VersionsUpselling v-if="countHiddenVersions > 0" class="px-5 pb-6" :message="message" />
  </section>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import { useVersionsStore } from '@/modules/viewer/store/useVersionsStore';
import VersionsCurrent from './VersionsCurrent.vue';
import VersionsSkeleton from './VersionsSkeleton.vue';
import VersionsList from './VersionsList.vue';
import { storeToRefs } from 'pinia';
import VersionsUpselling from './VersionsUpselling.vue';
import { useViewerTrack, TrackEvents } from '@/modules/viewer/composables/useViewerTrack';
import { onMounted } from 'vue';

const versionsStore = useVersionsStore();
const { loading, countHiddenVersions } = storeToRefs(versionsStore);
const { free } = storeToRefs(useOrganizationStore());
const { trackItemOwner } = useViewerTrack();

onMounted(() => {
  trackItemOwner(TrackEvents.VERSIONS_MODAL_OPENED);
});

const message = computed(() => {
  const hiddenVersions = countHiddenVersions.value;
  const versionText = hiddenVersions === 1 ? 'version' : 'versions';
  return `You have ${hiddenVersions} more ${versionText} available. On your plan, you can only see the last version.`;
});
</script>
